/**
 * Record – SVG icon.
 */
import Props from '@shared/types/props/pressable';
import Screen from '@screen';

/** Record indicator. */
export default function RecordIcon({ height, width }: Props) {
  return (
    <svg
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      height={`${(height || 32) * Screen.widthRatio}`}
      width={`${(width || 32) * Screen.widthRatio}`}
      viewBox='0 0 32 32'
    >
      <g id='iguide-icon-record'>
        <circle id='Ellipse 21' cx='16' cy='16' r='8' fill='#E00000' />
      </g>
    </svg>
  );
}
